/*
FormDate is a v-date-picker based on a calendar to select a data.
Parent components can syncronize their date fields with FormDate as follows:

            <FormDate
              :label="field label"
              v-model="parentDate"
            />
*/
import moment from 'moment'
import VDateTime from './../VDateTime/VDateTime.vue'
import textFieldMixin from '@/agilis/components/Form/utils/textFieldMixin.js'

export default {
  name: 'FormInstant',

  mixins: [textFieldMixin],

  components: {
    VDateTime
  },

  props: {
    value: String,
    format: String
  },

  data: () => ({
    date: null,
    menu: false
  }),

  created () {
    // expect value in UTC format with timezone (from java Instant, e.g. 2013-05-30T23:38:23.085Z)
    const momentValue = this.value ? moment(this.value) : moment().startOf('minute')

    // align date with string value expected by v-date-picker
    // TODO use i18n locale to configure v-date-picker format and headers
    const dateFormat = this.$t(this.format || 'format.instant')
    this.date = momentValue.format(dateFormat)

    // update parent with current value in UTC format
    this.$emit('input', momentValue.toISOString())
  },

  methods: {
    handleDatePickerInput (item, event) {
      // update parent with current value in UTC format
      this.$emit('input', moment(item).toISOString())
      this.menu = false
    }
  },

  watch: {
    value: function (val) {
      const momentValue = val ? moment(val) : moment().startOf('minute')
      const dateFormat = this.$t(this.format || 'format.instant')
      this.date = momentValue.format(dateFormat)
      this.$emit('input', momentValue.toISOString())
    }
  }
}
